import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getFlexSelectCustomStyle } from 'assets/styles/multiple_select';

const FlexSelectLogin = ({
  dataOptions,
  value,
  fieldName,
  placeholder = 'Selecione...',
  valueController,
  isMulti = false,
  labelName,
  valueName,
  closeMenuOnSelect = false,
  isClearable = false,
  isSearchable = true,
  isDisabled = false,
  minHeight = '',
  noOptionsMessage = () => 'Nenhuma Opção'
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let arrayOptions = [];
    dataOptions.forEach((option) => {
      arrayOptions.push({
        label: option[labelName],
        value: option[valueName]
      });
    });
    setOptions([...arrayOptions]);
  }, [dataOptions, labelName, valueName]);

  const getSelectValues = (values) => {
    // console.log('erererr', values);
    if (isMulti) {
      let capsule = [];
      values.length > 0 &&
        values.forEach((el) => {
          dataOptions.forEach((option) => {
            if (option[valueName] === el)
              capsule.push({
                label: option[labelName],
                value: option[valueName]
              });
          });
        });
      return capsule;
    } else {
      let capsule = [];
      dataOptions.forEach((option) => {
        if (option[valueName] === values)
          capsule.push({
            label: option[labelName],
            value: option[valueName]
          });
      });
      return capsule;
    }
  };

  const controlChange = (values) => {
    if (isMulti) {
      if (values && values.length > 0) {
        const a = values.map((l) => l.value);
        return valueController(fieldName, a);
      }
      return valueController(fieldName, []);
    } else {
      if (values) {
        return valueController(fieldName, values.value);
      }
      return valueController(fieldName, '');
    }
  };

  return (
    <>
      <Select
        isSearchable={isSearchable}
        isClearable={isClearable}
        isMulti={isMulti}
        name={fieldName}
        placeholder={placeholder}
        styles={getFlexSelectCustomStyle({ minHeight })}
        value={getSelectValues(value)}
        onChange={controlChange}
        closeMenuOnSelect={closeMenuOnSelect}
        classNamePrefix="react-select"
        fluid
        options={options}
        isDisabled={isDisabled}
        noOptionsMessage={noOptionsMessage}
      />
    </>
  );
};

export default FlexSelectLogin;
